import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  assets: {
    leftFileUrl: '',
    rightFileUrl: '',
    backgroundFileUrl: '',
    lottieFileUrl: ''
  }
};

const longhornThemeSlice = createSlice({
  name: 'longhornTheme',
  initialState,
  reducers: {
    setFileUrls(state, action) {
      state.assets = { ...state.assets, ...action.payload };
    }
  }
});

export const { setFileUrls } = longhornThemeSlice.actions;
export default longhornThemeSlice.reducer;
